/**
 * Text limits of the renderer's layout and accent splitting, without the layout itself: pure,
 * no Node dependency, so the editorial QA (qa.ts) runs in the web app's « Préparer un
 * carrousel » too. model/slides.ts re-exports both.
 */

/** Soft limits: beyond them text still renders (auto-fit) but a warning is emitted. */
export const TEXT_LIMITS = { coverTitle: 80, title: 90, subtitle: 220, ctaButton: 28 } as const;

/**
 * Comma-separated title fragments. A comma between two digits is a decimal
 * separator ("8,6 millions"), never a fragment boundary.
 */
export function splitAccents(accent: string | undefined): string[] {
  return (accent ?? "")
    .split(/(?<!\d),|,(?!\d)/)
    .map((part) => part.trim())
    .filter(Boolean);
}
